import { Stack, Typography, useTheme } from "@mui/material";

import { imageSource, Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";

const FooterBrand = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");

  return (
    <Stack>
      <Stack spacing={1} pt={4}>
        <img
          loading="lazy"
          src={imageSource.circleIcon}
          alt="logo"
          style={{ width: 120, height: 40 }}
        />
        {/* <Typography
          variant="h6"
          fontWeight="600"
          fontFamily="Work Sans"
          color={theme.palette.common.white}
          fontSize="16"
        >
          {Strings.footer.kozienMotor}
        </Typography> */}
      </Stack>

      <Typography
        variant="body2"
        sx={{ mt: 1, width: 275 }}
        fontFamily="Work Sans"
        fontWeight="400"
        color={theme.palette.common.white}
        fontSize="14"
      >
        {Strings.footer.ourVisionIs}
      </Typography>

      <Stack direction="row" sx={{ mt: isMobile ? 1 : 2 }}>
        <img
          src={imageSource.facebook}
          loading="lazy"
          alt="fb"
          style={{ width: 70, height: 70, display: "block", marginLeft: -20 }}
        />
        <img
          src={imageSource.x}
          loading="lazy"
          alt="x"
          style={{ width: 70, height: 70, display: "block", marginLeft: -16 }}
        />
        <img
          src={imageSource.instagram}
          loading="lazy"
          alt="insta"
          style={{ width: 70, height: 70, display: "block", marginLeft: -16 }}
        />
      </Stack>
    </Stack>
  );
};

export { FooterBrand };
